module.exports = __webpack_public_path__ + "static/img/1.77f67d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/1.jpg
// module id = S7SA
// module chunks = 1